import { colors } from "../../styles/style";

const separator = ({altStyle}) => {
  return (
    <div
      style={{
        border: 1.5,
        borderColor: !!altStyle ? colors.GRAY_5_COLOR : colors.GRAY_3_COLOR,
        width: "100%",
        height: 1,
        backgroundColor: !!altStyle ? colors.GRAY_5_COLOR : colors.GRAY_3_COLOR,
        marginBottom: 10,
        marginTop: 10,
      }}
    />
  );
};

export default separator;
